import { render } from "./paymentFailedHeader.vue?vue&type=template&id=24f9326d"
import script from "./paymentFailedHeader.vue?vue&type=script&lang=js"
export * from "./paymentFailedHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__